export const MFILES_REST_SEARCH_FORMAT = "yyyy-MM-dd";
export const MFILES_DATE_VALUE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const MFILES_INT_MIN = -2147483648;
export const MFILES_INT_MAX = 2147483647;
export const DEFAULT_FETCHED_ITEMS_COUNT_LIMIT = 1000;
export const DEFAULT_MAX_DATERANGE_IN_YEARS = 5;

// Builtin mandatory properties
export const CLASS_MFILES_PROPERTY_ID = 100;
export const WORKFLOW_STATE_MFILES_PROPERTY_ID = 39;

export const QUERYSTRING_CONFIG_PART = "config";
export const QUERYSTRING_SEARCH_PART = "search";
export const QUERYSTRING_VIEW_PART = "view";
export const QUERYSTRING_START_PART = "start";
export const QUERYSTRING_END_PART = "end";
export const QUERYSTRING_PRESHARED_KEY = "presharedkey";
export const QUERYSTRING_TOKEN_PART = "token";
export const QUERYSTRING_FILTER_PART = "filter";
export const QUERYSTRING_REFRESH_PART = "refresh";
export const QUERYSTRING_LANGUAGE_PART = "lng";
export const QUERYSTRING_SIDEBAR_WIDTH = "sidebarWidth";
export const QUERYSTRING_COLUMN_WIDTHS = "columnWidths";
export const QUERYSTRING_EXPAND_ALL = "expandAll";
export const QUERYSTRING_SORT_BY = "sortBy";

export const availableLanguages = ["en","fi"];

export const MFILES_LINK_VINCITEAM = "vinciteam";
export const VINCITEAM_URLSEARCHOBJECT = "PD.JD.URLSearchObject";
